import React from "react";
import IsNewClaimForCondition from "./IsNewClaimForCondition";
import CheckListForClaimBack from "./CheckListForClaimBack";
import Store from "./../../content/Store";
import Contentify from "../../content/Contentify";
import GetStartedButton from "./GetStartedButton";
import { connect } from "react-redux";
import styles from "../../assets/css/modules/makeAClaim/medical-treatment.css";
import { IS_NEW_CLAIM_CONDITION_CONTENT } from "./Constants";

export const MedicalTreatment = ({ isNewClaim, content }) => {
  const renderContent = () => {
    let checklistAndStartButton;
    let checklistContent;

    if (typeof isNewClaim === "boolean") {
      checklistContent = {
        ...content,
          checklist: isNewClaim
          ? content.newClaimChecklist
          : content.newClaimChecklist
      };

      checklistAndStartButton = (
        <React.Fragment>
          <div className={styles.inputWrapperForMedicalTreatment}>
            <CheckListForClaimBack content={checklistContent} />
          </div>
          <GetStartedButton />
        </React.Fragment>
      );
    }
    return checklistAndStartButton;
  };

  return (
    <React.Fragment>
      <div className="mt-5">
        <IsNewClaimForCondition />
      </div>
      <div name={IS_NEW_CLAIM_CONDITION_CONTENT}>{renderContent()}</div>
    </React.Fragment>
  );
};

MedicalTreatment.content = Store.MedicalTreatment;

export const mapStateToMedicalTreatment = (state) => ({
  isNewClaim: state.makeAClaimReducer.isNewClaim
});

export default connect(mapStateToMedicalTreatment)(
  Contentify(MedicalTreatment)
);
